module.exports = __webpack_public_path__ + "img/CNN-COVER.a7cdfa70.png";